module.exports = __webpack_public_path__ + "media/cover.9e521d76.mp4";